import React from 'react'
import { Link } from 'react-router-dom'

function Error() {
  return (
    <div  style={{width:"100vw",height:"100vh",margin:"0"}}>
    <div className="errpage">
      <h1 style={{textAlign:"center",color:"#008069",fontWeight:"800",fontSize:"3rem"}}>Page not found</h1>
      <h3 style={{textAlign:"center"}}><Link to="/" >Click here</Link> to go on home page.</h3>
    </div>
    </div>
  )
}

export default Error